import { createStyles } from 'antd-style';

const useAssetsPageStyles = createStyles(({ css }) => {
  return {
    statCardBase: css`
      width: 50%;
      border-radius: 15px;
      transition: all 0.3s;
      cursor: pointer;
      overflow: hidden;
      position: relative;
      display: block;
    `,
    statMaskImage: css`
      -webkit-mask-image: var(--mask-image);
      mask-image: var(--mask-image);
    `,
    statMaskActive: css`
      -webkit-mask-size: 100% 100%;
      mask-size: 100% 100%;
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-position: 0 0;
      mask-position: 0 0;
    `,
    statClipActive: css`
      -webkit-clip-path: url(#clipRoundedSlant);
      clip-path: url(#clipRoundedSlant);
    `,
    certificateActive: css`
      background-color: #74ffbb;
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
      height: 108px;
      padding: 16px 40px;
      border: none;
    `,
    certificateInactive: css`
      background-color: #74ffbb;
      height: 66px;
      padding: 16px 24px;
      border: 1px solid #182a48;
    `,
    computingActive: css`
      background-color: #41faf4;
      box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.05);
      height: 108px;
      padding: 16px 40px;
      border: none;
    `,
    computingInactive: css`
      background-color: #41faf4;
      height: 66px;
      padding: 16px 24px;
      border: 1px solid #182a48;
    `,
    watermarkImage: css`
      position: absolute;
      z-index: 0;
      width: 180px;
      height: 180px;
      right: 24px;
      top: 20px;
      opacity: 0.85;
    `,
  };
});

export default useAssetsPageStyles;
